import { render, staticRenderFns } from "./pi-user-tag.vue?vue&type=template&id=1be88e0f&"
import script from "./pi-user-tag.vue?vue&type=script&lang=js&"
export * from "./pi-user-tag.vue?vue&type=script&lang=js&"
import style0 from "./pi-user-tag.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports